module.exports = __webpack_public_path__ + "e972b0493d28a00137e8653ab898280a.svg";